import React from 'react'

const RoomCall = () => {
   return (
      <div className='flex items-center justify-center flex-wrap h-full gap-2 p-5'>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
         <div className='bg-slate-200 rounded-md w-[30rem] h-[25rem] p-10'>
            icon
         </div>
      </div>
   )
}

export default RoomCall